import { useEffect, useRef } from 'react'

/**
 * Atajos globales del PWA:
 *   - Ctrl/Cmd+K | Ctrl/Cmd+/ → abrir buscador
 *   - Ctrl/Cmd+J → toggle chat asistente
 *   - Ctrl/Cmd+B → plegar/desplegar sidebar (dispara event arquitecto:toggle-sidebar)
 *   - Esc cierra chat (manejado por el componente)
 */
export function useGlobalShortcuts(opts: { onOpenPalette: () => void; onToggleChat?: () => void }) {
  // Callbacks por ref: el listener se registra UNA vez y no se re-suscribe en cada render
  // (antes la dep [opts] —objeto recreado siempre— provocaba listener-thrash).
  const optsRef = useRef(opts)
  optsRef.current = opts
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const meta = e.metaKey || e.ctrlKey
      if (!meta) return
      if (e.key === 'k' || e.key === 'K' || e.key === '/') {
        e.preventDefault()
        optsRef.current.onOpenPalette()
      } else if (e.key === 'j' || e.key === 'J') {
        e.preventDefault()
        optsRef.current.onToggleChat?.()
      } else if (e.key === 'b' || e.key === 'B') {
        e.preventDefault()
        window.dispatchEvent(new CustomEvent('arquitecto:toggle-sidebar'))
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])
}
